import React, {useEffect, useState} from 'react';
import {DocTable, DocTitle} from '../../components';
import {preparePeopleTable} from './utils';
import {DocumentsBatch, VdkBookCopy, VDKResponse} from '../../types';
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";
import {QRFooter} from "../qr_footer/QRFooter";


export const VdkDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                            documents,
                                                                                            withVersions = true
                                                                                        }) => {
    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<VdkBookCopy>(
            (selectedDocument.document.document as unknown as VDKResponse).bookcopy
    )

    useEffect(() => {
        setDocument((selectedDocument.document.document as unknown as VDKResponse).bookcopy);
    }, [selectedDocument.document.version]);


    const fullAddress = `кв. ${doc.flatnum}, дом № ${doc.housenum} по ${doc.streetname}`;
    const peopleTableData = preparePeopleTable(doc);

    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={`Выписка из домовой книги № ${doc.docnum}`}
                              uid={doc.blockchainUid}
                              subtitle={fullAddress}/>
                </div>
                <div className="col-span-12 md:col-span-8">
                    <DocTable {...peopleTableData} />
                    <QRFooter blockchainUid={doc.blockchainUid}
                              // refDate={doc.data.fd}
                              // mfcInfoName={doc.data.firmName}
                              // mfcUserName={doc.data.userName}
                    />
                </div>
                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-last">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }
            </>
    );
};
